export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public object_id: string = "";
    // Middleware API - For reading well data from ADLS
    public apiUrl: string = "";
    public wellsApiKey: string = "";
    // Outbound API - For pushing data to WellView DB 
    public outboundApiUrl: string = "";
    public outboundApiKey: string = "";
    // Hardcoded bearer token (for local development only)
    public access_token: string = "";
    public token_type: string = "";
    // Role-based group IDs (flat structure for workspace roles)
    public legal: string = "";
    public admin: string = "";
    
    /**
     * Get all role mappings as an object for backward compatibility
     */
    public getRoleGroupMapping(): { [key: string]: string } {
        const mapping: { [key: string]: string } = {};
        if (this.legal) mapping['legal'] = this.legal;
        if (this.admin) mapping['admin'] = this.admin;
        return mapping;
    }
}
